import { Alert } from "antd";
import dayjsTZ from "../../../utils/dayjs";
import { WARNING_LABELS } from "../aquamanConstants";

// Everything the rotation engine could not resolve cleanly, in plain Albanian.
const WarningsBanner = ({ warnings }) => {
  if (!warnings || warnings.length === 0) return null;

  return (
    <Alert
      className="aquamanWarnings"
      type="warning"
      showIcon
      message={`${warnings.length} vërejtje nga gjenerimi i fundit`}
      description={
        <ul>
          {warnings.map((w, idx) => (
            <li key={idx}>
              {w.weekStart ? (
                <strong>{dayjsTZ(w.weekStart).format("DD/MM/YYYY")}: </strong>
              ) : null}
              {WARNING_LABELS[w.code] || w.code}
            </li>
          ))}
        </ul>
      }
    />
  );
};

export default WarningsBanner;
